import React, { useState } from 'react'
import ViewPosts from '../../pages/ViewPosts';
import JobPosting from '../../pages/JobPosting';
import HomePage from '../HorizontalScroll/HorizontalScroll';
import UserPosts from './UserPosts';
import { useSelector } from 'react-redux';


const PostsInfoCard = ({ userId }) => {
  const [curr, setCurr] = useState("My");
  const { user } = useSelector((state) => state.user);
  const isOwnProfile = user && user._id === userId;

  const Tab = ({ label, id }) => (
    <button
      onClick={() => setCurr(id)}
      className={`relative py-4 px-2 text-sm font-black uppercase tracking-widest transition-all ${
        curr === id ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'
      }`}
    >
      {label}
      {curr === id && (
        <div className="absolute bottom-0 left-0 w-full h-1 bg-blue-600 rounded-full" />
      )}
    </button>
  );

  return (
    <div className="flex flex-col h-full">
      <div className="flex bg-white px-8 space-x-8 border-b border-slate-50">
        <Tab label={isOwnProfile ? "My Posts" : "Posts"} id="My" />
        {isOwnProfile && <Tab label="Bookmarked" id="Saved" />}
        <Tab label="Liked" id="Liked" />
      </div>

      <div className="flex-grow bg-slate-50/30 overflow-y-auto">
        <UserPosts userId={userId} curr={curr} />
      </div>
    </div>
  );
};

export default PostsInfoCard
